<template>
  <div>
    <left-sidebar :ppa="ppa" />
    <right-sidebar :ppa="ppa" />
    <header-bp
      :user="user"
      :ppa="ppa"
    />
    <div class="header-spacer" />
    <div class="container">
      <div class="row">
        <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="clients-grid">
            <ul
              v-if="cats && cats.length"
              class="cat-list-bg-style align-center sorting-menu"
            >
              <li
                v-for="item in cats"
                :key="item.id"
                class="cat-list__item"
                :class="{ active: item.id === selectedCatId }"
              >
                <a
                  href="#"
                  class=""
                  @click="selectCat(item.id)"
                >{{ item.title }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="ui-block responsive-flex">
            <ticket-form />
            <div class="ui-block-title">
              <div class="h6 title">
                Tickets
              </div>
              <div class="form-group with-button">
                <select
                  v-model="selectedStatus"
                  class="has-bootstrap-select "
                  @change.prevent="changeStatus"
                >
                  <option
                    v-for="option in statuses"
                    :key="option.val"
                    :value="option.val"
                    :selected="option.val == selectedStatus"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </div>
              <div class="align-right">
                <form class="w-search">
                  <div class="form-group with-button">
                    <input
                      v-model="term"
                      class="form-control"
                      type="text"
                      :placeholder="searchText"
                    >

                    <button @click.stop.prevent="search1">
                      <svg
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        role="presentation"
                        class="sprite-icon olymp-magnifying-glass-icon"
                      >
                        <use
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          xlink:href="../../../static/sprites/icons.svg#olymp-magnifying-glass-icon"
                        />
                      </svg>
                    </button>
                  </div>
                </form>
                <a
                  href=""
                  @click.stop.prevent="changeType"
                >Change</a> {{ searchType }}
                <a
                  href="#"
                  class="btn btn-primary btn-md"
                  @click="$modal.show('ticket-form', {item: {title:'', status: 'ACTIVE', rank:0, cat_id: selectedCatId }})"
                >Create Ticket +</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="tickets && tickets.length"
        class="row"
      >
        <div
          v-for="item in tickets"
          :key="item.id"
          class="col-xl-4 col-lg-6 col-md-12 col-sm-12 col-xs-12"
        >
          <div class="ui-block">
            <!-- Birthday Item-->
            <div class="birthday-item inline-items">
              <div class="author-thumb">
                <img
                  src="../../../static/img/avatar2-sm.jpg"
                  alt="author"
                >
              </div>
              <div class="birthday-author-name">
                <label class="h6 author-name">
                  <router-link
                    :to="{ path: '/list/' + item.id }"
                    class="h3 post-title"
                  >
                    {{ item.title }}
                  </router-link>
                </label>
                <div class="birthday-date">
                  {{ item.status }}
                </div>
              </div>
            </div>

            <!-- ... end Birthday Item-->
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <!-- Pagination -->
          <pagination
            v-model="currentPage"
            :records="totalTickets"
            :per-page="perpage"
            @paginate="paginationChange"
          />
          <!-- ... end Pagination -->
        </div>
      </div>
    </div>
    <a
      href="#"
      class="back-to-top"
    >
      <app-icon
        name="olymp-stats-arrow-icon"
        tooltip="Back to top"
        color="white"
        size="medium"
      />
    </a>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import LeftSidebar from '../../components/common-apps/common/LeftSidebar.vue'
import RightSidebar from '../../components/common-apps/common/RightSidebar.vue'
import HeaderBp from '../../components/common-apps/common/HeaderBp.vue'
import AppIcon from "../../components/common-apps/common/AppIcon.vue";
import ticketStore from '../../store/modules/vocational/ticket.js'
import TicketForm from "../../components/vocational/ticket/TicketForm.vue"
import Pagination from 'vue-pagination-2'
// import {format} from "date-fns";

export default {
  name: 'TicketList',
  components: {
    LeftSidebar,
    RightSidebar,
    HeaderBp,
    AppIcon,
    TicketForm,
    Pagination
  },
  data () {
    return {
      term: '',
      searchText: 'Search articles by tag...',
      searchType: 'tag',
      selectedStatus: 'ALL',
      currentPage: 1,
      perpage: 15,
      statuses: [{ val: 'ALL', name: 'ALL'}, { val: 'ON_GOING', name: 'ON GOING'}, { val: 'ACTIVE', name: 'ACTIVE'}, { val: 'ON_HOLD', name: 'ON HOLD'}, { val: 'COMPLETE', name: 'COMPLETE'}]
    }
  },
  computed: mapState({
    tickets: state => state.ticket ? state.ticket.items : [],
    selectedCatId: state => state.ticket ? state.ticket.selectedCatId : 0,
    cats: state => state.ticket ? state.ticket.cats : [],
    totalTickets: state => state.ticket? state.ticket.totalItems : 0,
    ppa: state => state.account.ppa,
    user () {
      return !this.$store.getters['account/user'] ? { username: 'None' } : this.$store.getters['account/user']
    }
  }),
  mounted() {
    document.body.classList.add('month-page')
  },
  destroyed () {
    document.body.classList.remove('month-page')
  },
  created () {
    this.$store.dispatch('account/fetchUser')
    if (!this.$store.hasModule('ticket')) {
      this.$store.registerModule('ticket', ticketStore)
    }
    this.$store.dispatch('ticket/getCats')
    if (this.$route.params.type) {
      this.searchType = this.$route.params.type
      this.term = decodeURI(this.$route.params.term)
      let opts = { currentPage: 1, perpage: this.perpage, term: this.term, searchType: this.searchType, catid: this.selectedCatId }
      if (this.selectedStatus != 'ALL') {
        opts.status = this.selectedStatus;
      }
      this.$store.dispatch('ticket/search', opts)
    }  else {
      this.$store.dispatch('ticket/getTickets', {currentPage: 1, perpage: this.perpage, catid: this.selectedCatId || 1})
    }
  },
  beforeDestroy () {
    this.$store.unregisterModule('ticket')
  },
  methods: {
    selectCat (catid) {
      this.$store.commit('ticket/setCatId', catid)
      this.$store.dispatch('ticket/getTickets', {currentPage: 1, perpage: this.perpage, catid})
    },
    paginationChange (currentPage) {
      // eslint-disable-next-line
      let opts = { currentPage, perpage: this.perpage, catid: this.selectedCatId || 1 }
      if (this.selectedStatus != 'ALL') {
        opts.status = this.selectedStatus;
      }
      this.$store.dispatch('ticket/getTickets', opts);
    },
    search1 () {
      let aa = encodeURI(this.term);
      this.$router.push(`/list/search/${this.searchType}/${aa}`)
    },
    changeType () {
      if (this.searchType === 'tag') {
        this.searchType = 'title'
      } else {
        this.searchType = 'tag'
      }
      this.searchText = `Search articles by ${this.searchType}...`
    },
    changeStatus() {
      if (this.selectedStatus != 'ALL') {
        this.$store.dispatch('ticket/getTickets', {currentPage: 1, perpage: this.perpage, status: this.selectedStatus, catid: this.selectedCatId || 1})
      } else {
        this.$store.dispatch('ticket/getTickets', {currentPage: 1, perpage: this.perpage, catid: this.selectedCatId || 1})
      }

    }
  }
}
</script>

<style lang="scss">
// Bootstrap from node_modules has container smaller
@import '../../scss/Bootstrap/scss/bootstrap-reboot';
@import '../../scss/Bootstrap/scss/bootstrap';
@import '../../scss/Bootstrap/scss/bootstrap-grid';

@import '../../scss/ticket2';
// @import '../../scss/fonts';

/* required class */
.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 18px;
  line-height: 1.5;
  padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}

</style>
